var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"product-name"},[_vm._v(" "+_vm._s(_vm.callTitlelize(this.productName))+" ")]),_c('h5',{staticClass:"product-price"},[_c('strong',[_vm._v("Price:")]),_vm._v(" $"+_vm._s(this.productPrice))])])}
var staticRenderFns = []

export { render, staticRenderFns }